<template>
  <!-- 只给标题文本组件用 有more字段的 -->
  <div class="imgTextChild">
    <!-- 核心修改：单选框绑定 子组件自己的私有变量 localType，不再绑定父组件的props -->
    <el-radio-group
      v-model="localType"
      size="mini"
      class="radio-group"
      @change="handleChange"
    >
      <el-radio :label="1">无</el-radio>
      <el-radio :label="2" style="margin-left: 14px">自定义</el-radio>
    </el-radio-group>

    <!-- 核心判断：用子组件自己的 localType 判断显隐  -->
    <div style="display: flex; align-items: flex-start" v-if="localType === 2">
      <el-select
        style="width: 130px"
        v-model="datas.linkType"
        placeholder="请选择跳转类型"
        size="mini"
        class="type-select"
        @change="handleLinkTypeChange($event, 1)"
        clearable
      >
        <el-option label="内部链接" value="10"></el-option>
        <el-option label="外部链接" value="11"></el-option>
      </el-select>
      <div v-if="datas.linkType == 10" style="margin-left: 5px">
        <el-select
          v-model="datas.more.http.internalLink"
          placeholder="请选择内部页面"
          size="mini"
          class="content-select"
          clearable
          @change="handleLinkTypeChange($event, 2)"
        >
          <el-option
            v-for="page in pagesList"
            :key="page.pageId"
            :label="page.pageName"
            :value="page.pageId"
          >
          </el-option>
        </el-select>
        <el-button
          v-if="!datas.pageId"
          type="primary"
          size="mini"
          @click.stop="handleLinkTypeChange(NEW_PAGE_KEY, 3)"
          >+ 新建页面</el-button
        >
      </div>

      <el-input
        style="margin-left: 5px"
        v-if="datas.linkType == 11"
        v-model="datas.more.http.externalLink"
        placeholder="请输入链接，输入前确保可以访问"
        size="mini"
        class="content-input"
        clearable
      ></el-input>
    </div>
  </div>
</template>

<script>
export default {
  name: "LinkSelectInput",
  props: {
    // 父组件传入的默认值，只做初始化用，不做双向绑定
    type: {
      type: [Number, String],
      default: 1,
    },
    datas: {
      type: Object,
      required: true,
      default: () => ({
        linkType: "",
        http: {
          internalLink: "",
          externalLink: "",
        },
      }),
    },
  },
  data() {
    return {
      // ✅ 核心新增：子组件自己的私有变量，接收父组件的初始值
      localType: Number(this.type),
      NEW_PAGE_KEY: "_NEW_", // 新建页面的特殊key值
      currentItem: null,
      currentPageId: "",
    };
  },
  computed: {
    pagesList() {
      // 先过滤出首页等链接 后续根据需求操作
      return (
        this.$store.state.modules.templateData.pages.filter(
          (item) =>
            item.pageId !== "page_home" &&
            item.pageId !== "page_notification" &&
            item.pageId !== "page_activity" &&
            item.pageId !== "page_user" &&
            item.pageId !== "page_find",
        ) || []
      );
    },
  },
  // 监听父组件传的type变化，同步更新子组件的localType (可选，做了更健壮)
  watch: {
    type(val) {
      this.localType = Number(val);
    },
  },
  methods: {
    handleChange(event) {
      // 初始化跳转链接
      if (event == 1) {
        this.datas.more.http.internalLink = "";
        this.datas.more.http.externalLink = "";
      }
    },
    // 核心方法：处理跳转类型选择变化，同步更新父组件的datas.linkType
    handleLinkTypeChange(val, type) {
      if (type == 2) {
        //走的是 内部链接下拉选择事件
        console.log("LinkSelectInput子组件handleLinkTypeChange事件", val, type);
        //如果是内部链接下拉选项改变事件   生成pageID，同步vuex
      } else if (type == 3) {
        this.handleConfirm();
        // this.$emit("update:type", val);
      } else {
        console.log("跳转类型选择了", val);
        this.datas.more.httpType = val;
        this.datas.linkType = val;
        this.resetData(); //初始化
        this.$emit("update:type", val);
      }
    },
    //初始化
    resetData() {
      this.datas.more.http = {
        externalLink: "",
        internalLink: "",
      };
      // delete this.datas.pageId;
      // delete this.datas.pageName;
    },
    // 新建页面
    async handleConfirm(val) {
      const newPage = {
        pageId: this.datas.id || this.datas.pageId,
        isBack: true,
        pageName: this.datas.moduleName || this.datas.text,
        path: this.datas.id || this.datas.pageId,
        pageSetup: this.$store.state.modules.templateData.global,
        components: [],
      };
      this.datas.pageId = newPage.pageId;
      const result = await this.$store.dispatch(
        "modules/addDynamicPage",
        newPage,
      );
      if (result.success) {
        this.$message({
          message: "新建页面成功",
          type: "success",
        });
        this.dialogVisible = false;
        this.datas.more.http.internalLink = this.datas.pageId;
        this.currentPageId = this.datas.pageId;
        console.log(
          "新建页面成功结果",
          this.formData,
          this.datas,
          newPage,
          result,
          this.$store.state.modules.templateData,
          this.pagesList,
          this.currentPageId,
        );
      }
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep.el-select.type-select {
  .el-input {
    .el-input__inner {
      width: 120px;
    }
  }
}
</style>
